import { graphql } from 'gatsby';
import { RichTextElement } from '@kontent-ai/gatsby-components';
import {
  StyledBody,
  StyledButton,
  StyledColumnItem,
  StyledContent,
  StyledHeadline,
  StyledImage,
} from './ColumnBlockColumnItem.styles';

interface ColumnBlockColumnItemProps extends Queries.COLUMN_BLOCK_COLUMN_ITEMFragment {
  layout: Queries.kontent_item_column_block_elements_content_layout_enum;
}

const ColumnBlockColumnItem = ({ elements, layout }: ColumnBlockColumnItemProps) => {
  const { headline, body, cta, image, image_size: imageSize } = elements;

  const getImageSizes = (size?: string | null) => {
    if (size === 'size_128x128') {
      return [
        { width: 128, height: 128 },
        { width: 128, height: 128, breakpoint: 768 },
      ] as const;
    }
    return [
      { width: 64, height: 64 },
      { width: 64, height: 64, breakpoint: 768 },
    ] as const;
  };

  return (
    <StyledColumnItem layout={layout}>
      {image?.value && (
        <StyledImage
          src={image.value.url}
          alt={image.value.description || `Image for ${headline.value}`}
          sizes={getImageSizes(imageSize?.value)}
          imageSize={imageSize?.value}
        />
      )}
      <StyledContent>
        <StyledHeadline>{headline.value}</StyledHeadline>
        <StyledBody>
          <RichTextElement value={body.value} />
        </StyledBody>
        {cta?.value && (
          <span>
            <StyledButton {...cta.value} variant="tertiary" />
          </span>
        )}
      </StyledContent>
    </StyledColumnItem>
  );
};

export const fragment = graphql`
  fragment COLUMN_BLOCK_COLUMN_ITEM on kontent_item_column_block_column_item {
    system {
      id
    }
    elements {
      headline {
        value
      }
      image {
        value {
          url
          description
        }
      }
      image_size {
        value
      }
      body {
        value
      }
      cta {
        value {
          ...LINK
        }
      }
    }
  }
`;

export default ColumnBlockColumnItem;
